<template>
<div>
  <div class="content">
    <div class="cont-list">
      <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
      <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
    </div>
    <div class="header">
      <div class="left">
        <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
      </div>
      </div>
  
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="拣货单号" min-width="170">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="purchaseApplyNo" min-width="150" label="请领单号"></el-table-column>
        <el-table-column prop="applyDeptName" label="请领科室"></el-table-column>
        <el-table-column prop="warehouseName" label="拣货库房"></el-table-column>
        <el-table-column prop="createdUserName" label="创建人"></el-table-column>
        <el-table-column  label="审批人" width="100" align="center" prop="approverNames">
          <template slot-scope="scope">
            {{ scope.row.approverNames?scope.row.approverNames:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80" >
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="pickingStatusName" label="拣货状态"></el-table-column>
          <el-table-column prop="isOutStockName" label="是否已出库"></el-table-column>
     
          <el-table-column prop="createdTime" label="创建时间">
            <template slot-scope="scope">
              {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
            </template>
          </el-table-column>
        <el-table-column width="160" prop="effectiveTime" label="生效时间">
          <template slot-scope="scope">
            <div>
              {{ parseTime(new Date(scope.row.effectiveTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
            </div>
      
          </template>
        </el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status == 1 " type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-else-if="
                  scope.row.status != 1 &&
                  scope.row.status != 2 &&
                  tableAcl.indexOf('Edit') != -1
                " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
              <el-button v-if="scope.row.isOutStock==0&&scope.row.pickingStatus!=0" type="text" v-preventReClick @click="handleOutbound(scope.row)" class="margin-left20 color-blue">出库</el-button>
          </template>
        </el-table-column>
      </el-table>
 
  </div>
  <div class="pagination">
    <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
    </el-pagination>
  </div>
  <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
</div>
</template>

<script>
import {
  GetPickingStocks,
RemovePickingStock,
CheckHasRunningPurchaseApply,
  CreateApplyOuts

} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  ApproveStatusOptions,
  PickingTypeOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetPickingStocks,
      RemoveAction: RemovePickingStock,
      editPath: "pickingStock-edit",
      PickingTypeOptions:PickingTypeOptions,
      filterOptions: [{
          name: "拣货单号",
          type: "input",
          code: "no",
        },
        {
          name: "请领单号",
          type: "input",
          code: "purchaseApplyNo",
        },
          {
        name: "流程状态",
        type: "select",
        code: "statuses",
        multiple: true,
        data: ApproveStatusOptions,
      },
             {
        name: "拣货状态",
        type: "select",
        code: "pickingStatus",
        data: PickingTypeOptions,
      },
        {
          name: "创建时间",
          type: "date",
          code: "date",
          defaultValue: this.getDefaultDateRange(), // [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],//],
          startDateCode: "startDate",
          endDateCode: "endDate",
        },
      ],
    };
  },
  methods: {
    showRFIDDialog(row) {
      // this.$router.push("/pack-edit?category=0&id=" + row.id);
      this.routePushWithParams("/pack-edit", this.query, {
        category: 2,
        id: row.id
      });
    },
        getDefaultDateRange () {
      var endDate = new Date();
      var start = new Date(new Date().setDate(new Date().getDate() - 30));
      // 开始日期转换为00:00:00
      var startDate = new Date(
        `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()} 00:00:00`
      );

      return [startDate, endDate];
    },
    handleOutbound(row){
      this.loading = true
      let that = this
      let createApplyOut = function(){
        CreateApplyOuts({id:row.id}).then(res=>{
        if(res.returnData){
          that.loading = false
          let ons = res.returnData.join('、')
          that.$message({
            message: `已生成请领出库单：${ons}，请及时审核`,
            type: "success",
          });
        }
      })
      }
      CheckHasRunningPurchaseApply({id:row.id}).then(res=>{
        if(res.errorMessage){
          this.$confirm(res.errorMessage, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         createApplyOut()
        }).catch(() => {
          that.loading = false
        });
        }else{
          createApplyOut()
        }

      })
   
      // this.routePushWithParams("/apply-out-stock-edit", this.query, {
      //   formMode: 1,
      //   outboundId: row.id
      // });
    },
  },
  mounted() {
    
  },
  created(){
        var dateArr = this.getDefaultDateRange();
    this.query.startDate = this.parseTime(dateArr[0]);
    this.query.endDate = this.parseTime(dateArr[1]);
  }
};
</script>

<style lang="scss" scoped>

</style>

<style>
.el-message-box__message{
  width: 80%;
  display: inline-block;
  word-wrap: break-word;
}
</style>